import { Button, ButtonProps } from "antd"
import styles from "./styles.module.scss"
import classNames from "classnames"

const CircleButton: React.FC<ButtonProps> = ({
  shape = "circle",
  className,
  ...props
}) => {
  return (
    <Button
      shape={shape}
      className={classNames(styles.circle_button, className)}
      {...props}
    />
  )
}

export default CircleButton
